module.exports = {
  clientId: 7,
  	
  default_login: '',
  default_pass: '',
  mode: 'live',
  hide_fix_damages: true,
  hide_picked_up: true,
  hide_sell_with_license_plate: true,
  hide_sales_preference: true,
  disable_SIRV:true,
  hide_transport_card: true,
  hide_website_card : true,
  hide_inspection_card : true,
  hide_photos_card : true,
  hide_other_buttons : true,
  hide_inspection_filter : true,
  hide_mandatory_field_outgoing_order : true,
  hide_transaction_result : true,
  hide_products : true ,
  hide_bpm_card : true ,
  hide_task_card : true,
  hide_rdw_card : true,
  hide_payment_filter : true,
  hide_company_structure_card: true,
  hide_counterscard: true,
autohuis_salland_installation: true, 
 autohuissalland_installation: true,
  vehicle_status_1 : 'Geen eigendom',
  VEHICLE_WS2_1_GENERAL_PHOTOS : [
  'left_front',
        'linker-zijkant',
        'rechtsachter',
        'rechter-zijkant',
        'voorkant',
        'achterkant',
        'dashboard',
        'stuur',
        'tellerstand',
        'navigatie',
        'parkeercamera',
        'radio-dab',
        'extra-dashboard',
        'versnellingspook',
        'airco',
        'bediening-navigatie',
        'start/stop',
        'zijkant-dashboard',
        'bestuurdersstoel',
        'achterbank',
        'kofferbak',
        'velgen',
        'lampen',
        'extra-exterieur',
        'onderhoud1',
        'onderhoud2',
        'onderhoud3',
        'motorruimte'
],

  user_filter_list : [
    {
      label:'admin',
      value:1
    }
  ],

google_maps_api_key: "AIzaSyAzQOd9IQpDtlFtrk8Cb_imsvHfeF-yDMk",

 requiredFieldsPersonal: [
          "empty_weight",
          "number_of_seats",
          "interior_color",
          "interior_type",
          "power_axle",
          "trailer_with_brakes",
          "middleaxle_trailer_with_brakes",
          "mileage",
          "brand_name",
          "model_name",
          "model_info",
          "date_first_allowance",
          "body_type",
          "base_color",
          "transmission_type",
          "fuel_type",
          "co2_rdw",
          "euro_class",
          "verbruik",
          "energy_label",
        ],

requiredFieldsCommercial : [
  "number_of_seats",
  "power_axle",
  "trailer_with_brakes",
  "middleaxle_trailer_with_brakes",
  "technical_max_weight_vehicle",
  "mileage",
  "brand_name",
  "model_name",
  "model_info",
  "date_first_allowance",
  "body_type",
  "base_color",
  "transmission_type",
  "fuel_type",
  "co2_rdw",
  "euro_class",
  "verbruik",
  "energy_label",
        ],

requiredFieldsElectric :[
  "battery_capacity",
  "consumption_KwH",
  "max_chargingspeed_DC",
],


 hexon_portals :
  [
	'hexonwebsite1',
	'autocenter',
	'autowereld',
	'marktnet',
	'nederlandmobiel',
	'tweedehands',
	'gaspedaal',
	'dtclease',
	'autotrack',
	'autoonline',
	'123leasen',
	'financialleaseforyou',
	'interlease',
	'occasionvoorraad',
	'autokan',
	'sld',
	'viabovag',
	'a1blease'
  ],

optionsList_inspection : [
    { title: 'Algemeen',    },
    '1e Eigenaar',
    '4 5 Hoofdsteunen',
    '6 versnellingen',
    'Airco ECC',
    'Airco',
    'Armsteun',
    'Bagage-afdekhoes',
    'Camera achter',
    'CV op afstand',
    'Cruise control',
    'Dealer onderhouden',
    'Elektrisch bedienbare achterklep',
    'Elektrische ramen',
    'Elektrische spiegels',
    'Getint glas',
    'Hoogte verstelbare stoel',
    'Isofix bevestiging',
    'Lederen bekleding',
    'Lichtmetalen velgen',
    'Metallic lak',
    'Memory stoelen',
    'Navigatiesysteem',
    'Panoramadak',
    'Parkeersensor achter',
    'Parkeersensor voor',
    'Schuif-kanteldak',
    'Stoelverwarming voor',
    'Stuurwiel multifunctioneel',
    'Trekhaak met vaste kogel',
    'Virtual Cockpit',
    'Xenon koplampen',
    //'camera voor',
    //'Hoogte verstelbare stoel',
    {
      title: 'Front',
    },
    'Bi-xenon koplampen',
    'Camera-voor',
    'Koplampen adaptief',
    'Koplampreiniging',
    'Laser LED koplampen',
    'LED dagrijverlichting',
    'LED koplampen',
    //'Halogeen koplampen',
    'Mistlampen voor adaptief',
    'Mistlampen voor',
    'Parkeersensor voor en achter',
    //'parkeersensor voor',
{
      title: 'Side',
    },
    'Buitenspiegels elektrisch verstelbaar',
    //'Buitenspiegels carrosseriekleur',
    'Buitenspiegels elektrisch inklapbaar',
    'Cabriolet kap',
    'Dakrails',
    'Dodehoek detectie',
    'Side-skirts',
    'Sportpakket',
    //'Two-tone (metaal) kleur',
    'Verhoogd dak',
    {
      title: 'Back',
    },
    'Achterspoiler',
    'Dakspoiler',
    'Laadbak',
    'Laadlift',
    'LED achterlichten',
    'Trekhaak met afneembare kogel',
    'Trekhaak wegklapbare kogel',
    {
      title: 'Comfort',
    },
    'Autopilot',
    'Aanhanger assistent',
    'Achteruitrij assistent',
    'Achteruitrijcamera',
    'Adaptief demping systeem',
    'Afdaal assistent',
    'Airco separaat achter',
    'ABS',
    'Anti doorSlip Regeling',
    'Automatische snelheids begrenzing',
    'Autonomous Emergency Braking',
    'Bandenspanningscontrolesysteem',
    'Bots waarschuwing systeem',
    'Brake assist system',
    'Camera voor',
    'Cruise control adaptief',
    'Elektrisch bedienbare kap',
    'Elektrische stoelen',
    'Elektronisch Stabiliteits Programma',
    'Head-up display',
    'Hill hold functie',
    'Keyless entry',
    'Keyless start',
    'Kruisend verkeer detectie',
    'Luchtvering',
    'Nachtzicht-assistent',
    'Parkeer assistent',
    'Regensensor',
    'Rijstrooksensor',
    'Roll Stability Control',
    'Rondomzicht camera',
    'Sportonderstel',
    'Spraakbediening',
    'Standkachel',
    'Start/stop systeem',
    'Stuurbekrachtiging',
    'Stuurwiel verwarmd',
    'Uitwijk assistent',
    'Verkeersbord detectie',
    'Vermoeidheids herkenning',
    'Verwarmbare voorruit',
    'Verwarmde voorruit',
'Verwarmde voorruit',
    'VoorStoelen in hoogte verstelbaar',
    //'achteruitrij assistent',
    //'autonome parkeerfunctie',
    {
      title: 'interior',
    },
    //'Achter interieur',
    'Achterbank armsteun',
    'Achterbank verwarmd',
    'Alcantara bekleding',
    //'alcantara interieurdelen',
    //'aluminium interieur afwerking',
    //'carbonafwerking interieur',
    'derde zitrij',
    //'houtafwerking interieur',
    //'Kofferruimte',
    'Lederen bekleding',
    'Lederen sportstuur',
    'Lederen stuur',
    'Lederen/alcantara bekleding',
    'Lederen/stof bekleding',
    'Lederen/velours bekleding',
    'Lederen/stof bekleding',
    'Lederen/velours bekleding',
    'Niveauregeling automatisch',
    'Schakelmogelijkheid stuurwiel',
    'Sportief interieur',
    'Stoel ventilatie',
    //'stoel ventilatie voor en achter',
    //'stoel ventilatie voor',
    //'Stoffen bekleding',
    'Velours bekleding',
    'Velours/alcantara bekleding',
    //'Voor interieur',
    'Zonnescherm zijruiten',
    'Zwarte hemelbekleding',
    //'stoelverwarming voor',
    //'voor stoelen verwarmd',
    {
      title: 'multimedia',
    },
    'Android auto',
    'Apple carplay',
    'Audio installatie premium',
    'Bluetooth telefoonvoorbereiding',
    'DAB+ radio',
    'Navigatiesysteem full map',
    'Draadloze telefoonlader',
    'Radio CD speler',
    'Radio',
    'Virtual cockpit',
    // 'Navigatie groot scherm',
    {
      title: 'milieu',
    },
    'Emissienorm Euro 4',
    'Emissienorm Euro 5',
    'Emissienorm Euro 6',
    //'roetfilter',
    {
      title: 'bedrijfswagen',
    },
    'Achterdeuren',
    'Achterklep',
    'Bullbar',
    'Dubbele cabine',
    'Elektrische schuifdeur',
    'Extra zijschuifdeur',
    'Houtvloer',
    'Koelwagenuitvoering',
    'Lat-om-lat betimmering laadruimte',
    'Schuifdeur',
    'Sidebars',
    'Treeplanken',
    'Tussenschot',
    'Zijschuifdeur links',
    'Zijschuifdeur rechts',
    {
      title: 'other',
    },
    '4WD',
    'Aardgas installatie',
    'Airbags',
    'Alarm',
    'Buitenspiegels verwarmbaar',
    'Dashboardcamera',
    'Keramische remschijven',
    'Kleur parelmoer',
    'Lpg installatie',
    'Metaalkleur parelmoer',
    //'mica kleur',
    '3-persoons uitvoering',
    '5-persoons uitvoering',
    '6-persoons uitvoering',
    '7-persoons uitvoering',
    '8-persoons uitvoering',
  ],

inspection_impressions: true,
  inspection_attention_incidents: true,
  inspection_v2: true,

};
         
